// store/rootReducer.ts
import { combineReducers, type Action } from '@reduxjs/toolkit';

import registrationReducer from '@/store/slices/registration/registrationSlice'
import authReducer from '@/store/slices/auth/authSlice';
import userReducer from '@/store/slices/user/userSlice';
import SixDetailReducer from '@/store/slices/sixDetail/sixDetailSlice';
import CreateSixReducer from '@/store/slices/createSix/createSixSlice';
import SixCatalogReducer from '@/store/slices/sixCatalog/sixCatalogSlice';
import UIReducer from '@/store/slices/ui/uiSlice';
import connectionSliceReducer from '@/store/slices/poc/connectionSlice';
import pocAuthSliceReducer from '@/store/slices/poc/pocAuthSlice';
import messagingSliceReducer from '@/store/slices/poc/messagingSlice';
import heliaSliceReducer from '@/store/slices/poc/heliaSlice';
import organizationReducer from '@/store/slices/organization/organizationSlice';
import cloneQueueReducer from '@/store/slices/poc/cloneQueueSlice';
import fileKeyFacilitationReducer from '@/store/slices/fileKey/fileKeyFacilitationSlice';
import passwordUpdateReducer from '@/store/slices/passwordUpdate/passwordUpdateSlice';

// String literal to avoid circular dependency (logoutThunk -> store -> rootReducer)
const LOGOUT_FULFILLED = 'auth/logout/fulfilled';

const combinedReducer = combineReducers({
  messaging: messagingSliceReducer,
  helia: heliaSliceReducer,
  cloneQueue: cloneQueueReducer,
  fileKeyFacilitation: fileKeyFacilitationReducer,
  passwordUpdate: passwordUpdateReducer,

  p2pConnection: connectionSliceReducer,
  pocAuth: pocAuthSliceReducer,
  registration: registrationReducer,
  auth: authReducer,
  user: userReducer,
  organization: organizationReducer,
  sixDetail: SixDetailReducer,
  createSix: CreateSixReducer,
  sixCatalog: SixCatalogReducer,
  ui: UIReducer
});

export const rootReducer = (state: ReturnType<typeof combinedReducer> | undefined, action: Action) => {
  if (action.type === LOGOUT_FULFILLED) {
    return combinedReducer(undefined, action);
  }
  return combinedReducer(state, action);
};

// Infer the `RootState` type from the root reducer
export type RootState = ReturnType<typeof combinedReducer>;
